<div class="page-container">
  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
  <div class="page-header">
    <h1 class="page-title">{{ 'pages.jobs.title' | transloco }}</h1>
    <p class="page-description">{{ 'pages.jobs.description' | transloco }}</p>
  </div>

  <!-- Mobile-only: tab strip replaced with a native select dropdown.
       Hidden ≥ md viewport via SCSS, where mat-tab-group takes over. -->
  <div class="jobs-tabs-mobile">
    <select
      class="jobs-tabs-mobile__select"
      [ngModel]="selectedIndex"
      (ngModelChange)="onMobileSelectChange($event)"
      [attr.aria-label]="'pages.jobs.title' | transloco">
      <option *ngFor="let slug of tabs; let i = index" [ngValue]="i">
        {{ ('pages.jobs.tabs.' + slug) | transloco }}
      </option>
    </select>
    <i class="fas fa-chevron-down jobs-tabs-mobile__chevron" aria-hidden="true"></i>
  </div>

  <mat-tab-group class="jobs-tabs-desktop" mat-align-tabs="start" [(selectedIndex)]="selectedIndex" (selectedIndexChange)="onTabChange($event)">
    <mat-tab label="{{ 'pages.jobs.tabs.applied' | transloco }}">
      <div class="tab-content">
        <app-applied-jobs></app-applied-jobs>
      </div>
    </mat-tab>

    <mat-tab label="{{ 'pages.jobs.tabs.saved' | transloco }}">
      <div class="tab-content">
        <app-saved-jobs></app-saved-jobs>
      </div>
    </mat-tab>

    <mat-tab label="{{ 'pages.jobs.tabs.recommended' | transloco }}">
      <div class="tab-content">
        <app-recommended-jobs></app-recommended-jobs>
      </div>
    </mat-tab>
  </mat-tab-group>

  <!-- Mobile-only content driven by the select above -->
  <div class="jobs-tabs-mobile-content">
    <div [ngSwitch]="selectedIndex">
      <app-applied-jobs *ngSwitchCase="0"></app-applied-jobs>
      <app-saved-jobs *ngSwitchCase="1"></app-saved-jobs>
      <app-recommended-jobs *ngSwitchCase="2"></app-recommended-jobs>
    </div>
  </div>
</div>
